<template>
    <div class="te-price te-price-list__row">
        <div class="te-price__type">
            <span>{{name}}</span>
        </div>
        <div class="te-price__amount">
            <span>{{formattedPrice}}</span>
        </div>
        <div class="te-price__quantity">
<!--            <label>-->
                <input class="te-form-control" type="number" name="quantity" min="0" :max="limit" v-model="quantity" :tabindex="tabIndex" @input="onQuantityChange">
<!--            </label>-->
        </div>
    </div>
</template>

<script>
    import format from '../services/format'

    export default {
        name: "Price",

        data() {
            return {
                quantity: 0,
            };
        },


        props: {
            // value: {
            //     type: Object,
            //     required: true
            // },
            name: {
                type: String,
                required: true
            },
            currency: {
                // type: String,
                type: Object,
                // required: true
            },
            amount: {
                type: Number,
                required: true
            },
            limit: {
                type: Number,
                default: null
            },
            defaultQuantity: {
                type: Number,
                default: 0
            },
            tabIndex: {
                type: Number,
                default: 1
            },
            language: {
                type: Object
            },
        },

        computed: {
            formattedPrice: function() {
                if(this.amount === 0) {
                    return this.languageSettings.free;
                }
                return format.price(this.currency, this.amount);
            },

            languageSettings: function() {
                const defaultSettings = {
                    free: 'Free',
                };
                return Object.assign(defaultSettings, this.language);
            },
        },

        methods: {
            onQuantityChange() {
                if(this.limit && this.quantity > this.limit) this.quantity = this.limit;
                this.$emit('change', this.quantity);
                // this.$emit('input', this.value);
            },

            resetQuantity() {
                this.quantity = 0;
            }
        },

        watch: {
            amount: function() {
                this.quantity = 0;
            },
            defaultQuantity: function() {
                this.quantity = this.defaultQuantity;
            }
        },

        created() {
            this.quantity = this.defaultQuantity;
        }
    }
</script>

<style scoped>

</style>
